<template>
  <div
    :id="contentId"
    class="inspection-pdf direction-ltr"
    :style="{ display: pdfContentDisplay }"
  >
    <div class="title">
      VEHICLE INSPECTION REPORT
      <canvas ref="arabicTitleCanvas" class="arabic-canvas"></canvas>
    </div>

    <table class="header-table">
      <tbody>
        <tr>
          <td class="header-meta">
            <table class="meta-table">
              <tbody>
                <tr v-for="field in infoFields" :key="field.key">
                  <td class="label-en">{{ field.en }}</td>
                  <td class="value">{{ form[field.key] || "" }}</td>
                  <td class="label-ar">{{ field.ar }}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td class="header-preview">
            <div class="vehicle-preview">
              <img src="@/assets/images/img_bus.png" alt="vehicle-preview-1" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <table class="check-layout">
      <tbody>
        <tr>
          <td class="check-column">
            <table class="check-table">
              <thead>
                <tr>
                  <th class="notes">مالحظات</th> 
                  <th class="narrow">منع الخروج</th>
                  <th class="narrow">X/✓</th>
                  <th class="text-en">ITEM</th>
                  <th class="text-ar">البند</th>
                  <th class="narrow">الرقم</th>
                  <th class="group-col"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in leftChecklist" :key="`left-${row.no}`">
                  <td class="notes-cell">{{ row.notes || "" }}</td>
                  <td class="center"></td>
                  <td class="center">{{ row.en || row.ar ? (row.checked ? "✓" : "X") : "" }}</td>
                  <td class="text-en">{{ row.en }}</td>
                  <td class="text-ar">{{ row.ar }}</td>
                  <td class="center">{{ row.no }}</td>
                  <td
                    v-if="row.isGroupStart"
                    class="group-label"
                    :rowspan="row.groupRowspan"
                  >
                    <span class="group-label-text">
                      {{ row.groupEn || row.groupAr }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td class="check-column">
            <table class="check-table">
              <thead>
                <tr>
                  <th class="notes">مالحظات</th>
                  <th class="narrow">منع الخروج</th>
                  <th class="narrow">X/✓</th>
                  <th class="text-en">ITEM</th>
                  <th class="text-ar">البند</th>
                  <th class="narrow">الرقم</th>
                  <th class="group-col"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in rightChecklist" :key="`right-${row.no}`">
                  <td class="notes-cell">{{ row.notes || "" }}</td>
                  <td class="center"></td>
                  <td class="center">{{ row.en || row.ar ? (row.checked ? "✓" : "X") : "" }}</td>
                  <td class="text-en">{{ row.en }}</td>
                  <td class="text-ar">{{ row.ar }}</td>
                  <td class="center">{{ row.no }}</td>
                  <td
                    v-if="row.isGroupStart"
                    class="group-label"
                    :rowspan="row.groupRowspan"
                  >
                    <span class="group-label-text">
                      {{ row.groupEn || row.groupAr }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <table class="approval-table">
      <tbody>
        <tr>
          <td class="label">Checked by:</td>
          <td class="value">{{ form.checkedBy || "" }}</td>
          <td class="label ar">فحص بواسطة:</td>
        </tr>
        <tr>
          <td class="label">Employee ID:</td>
          <td class="value">{{ form.checkedByEmployeeId || "" }}</td>
          <td class="label ar">رقم بطاقة الموظف:</td>
        </tr>
        <tr>
          <td class="label">Notes:</td>
          <td class="value">{{ form.notes || "" }}</td>
          <td class="label ar">ملاحظات:</td>
        </tr>
      </tbody>
    </table>

    <div class="bottom-section">
    <table class="driver-table">
      <tbody>
        <tr>
          <td class="label">First Driver Name:</td>
          <td class="value">{{ form.firstDriverName || "" }}</td>
          <td class="label">Signature:</td>
          <td class="value">{{ form.firstDriverSignature || "" }}</td>
          <td class="label">Second Entry:</td>
          <td class="value">{{ form.firstDriverSecondEntry || "" }}</td>
          <td class="label">Second Exit:</td>
          <td class="value">{{ form.firstDriverSecondExit || "" }}</td>
        </tr>
        <tr>
          <td class="label">Second Driver Name:</td>
          <td class="value">{{ form.secondDriverName || "" }}</td>
          <td class="label">Signature:</td>
          <td class="value">{{ form.secondDriverSignature || "" }}</td>
          <td class="label">Second Entry:</td>
          <td class="value">{{ form.secondDriverSecondEntry || "" }}</td>
          <td class="label">Second Exit:</td>
          <td class="value">{{ form.secondDriverSecondExit || "" }}</td>
        </tr>
      </tbody>
    </table>

    </div>

    <div class="signature-section">
      <img src="@/assets/logo/SSS/saptco signiture.png" alt="saptco-signature" class="saptco-signature" />
    </div>
  </div>
</template>

<script>
import {
  DEFAULT_LEFT_INSPECTION_CHECKLIST,
  DEFAULT_RIGHT_INSPECTION_CHECKLIST,
} from "@/utilities/vehicleInspectionChecklist";

export default {
  name: "VehicleInspectionReportPDF",
  props: {
    pdfContentDisplay: {
      type: String,
      default: "block",
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
    contentId: {
      type: String,
      default: "vehicleInspectionPdfContent",
    },
    rightItems: {
      type: Array,
      default: () => [],
    },
    leftItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      infoFields: [
        { key: "date", en: "Date:", ar: ":التاريخ والوقت" },
        { key: "tripNo", en: "Trip No. / Odoo system:", ar: "رقم الرحلة / النظام التشغيلي:" },
        { key: "station", en: "Station:", ar: ":الفرع" },
        { key: "route", en: "Route / TO:", ar: "الرحلة من / إلى :1" },
        { key: "driver1Name", en: "Driver 1 name:", ar: ":اسم السائق الأول" },
        { key: "driver1Id", en: "Driver 1 ID:", ar: ":رقم هوية السائق الأول" },
        { key: "driver2Name", en: "Driver 2 name:", ar: ":اسم السائق الثاني" },
        { key: "vehicleNo", en: "Vehicle No.", ar: ":رقم تشغيل الحافلة" },
        { key: "kmOut", en: "KM OUT:", ar: ":كيلو متر الخروج" },
        { key: "dateTimeIn", en: "Date/Time In:", ar: ":تاريخ/وقت الدخول" },
        { key: "kmIn", en: "Km In:", ar: ":كيلو متر الدخول" },
      ],
    };
  },
  mounted() {
    this.drawArabicTitle();
  },
  watch: {
    pdfContentDisplay(val) {
      if (val === 'block') this.$nextTick(() => this.drawArabicTitle());
    },
  },
  methods: {
    drawArabicTitle() {
      const canvas = this.$refs.arabicTitleCanvas;
      if (!canvas) return;
      const text = 'تقرير فحص الحافلات';
      const fontSize = 13;
      const font = `bold ${fontSize}px Tahoma, Arial, sans-serif`;
      // measure
      const ctx = canvas.getContext('2d');
      ctx.font = font;
      const width = Math.ceil(ctx.measureText(text).width) + 10;
      const height = fontSize + 8;
      canvas.width = width * 2;
      canvas.height = height * 2;
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.scale(2, 2);
      ctx.font = font;
      ctx.fillStyle = '#1a1a2e';
      ctx.direction = 'rtl';
      ctx.textAlign = 'right';
      ctx.textBaseline = 'middle';
      ctx.fillText(text, width - 4, height / 2);
    },
  },
  computed: {
    form() {
      return this.formData || {};
    },
    rightChecklist() {
      return this.rightItems.length
        ? this.rightItems
        : DEFAULT_RIGHT_INSPECTION_CHECKLIST;
    },
    leftChecklist() {
      return this.leftItems.length
        ? this.leftItems
        : DEFAULT_LEFT_INSPECTION_CHECKLIST;
    },
  },
};
</script>

<style lang="scss" scoped>
.inspection-pdf {
  width: 210mm;
  min-height: 297mm;
  height: 297mm;
  margin: 0 auto;
  padding: 4mm 5mm;
  box-sizing: border-box;
  color: #222;
  background: #fff;
  font-family: 'Tahoma', Arial, Helvetica, sans-serif;
  font-size: 8.2px;
  line-height: 1.15;
  overflow: hidden;
  position: relative;
}

.title {
  text-align: center;
  font-weight: 700;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 3.5mm 0 3.5mm;
  margin-bottom: 3.2mm;
  font-size: 10px;
  letter-spacing: 0.02em;
}

.arabic-canvas {
  margin-inline-start: 2mm;
  vertical-align: middle;
}

.header-table,
.check-layout,
.approval-table,
.driver-table,
.meta-table,
.check-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.header-table {
  margin-bottom: 1.8mm;
}

.header-meta {
  width: 52%;
  vertical-align: top;
  padding-inline-end: 1.5mm;
}

.header-preview {
  width: 48%;
  vertical-align: top;
}

.meta-table td,
.check-table td,
.check-table th,
.approval-table td,
.driver-table td {
  border: 0.5px solid #000;
  padding: 0.9mm 1mm;
  vertical-align: middle;
  box-sizing: border-box;
}

.meta-table .label-en {
  width: 31%;
  font-weight: 600;
}

.meta-table .value {
  width: 39%;
}

.meta-table .label-ar {
  width: 30%;
  text-align: right;
  direction: rtl;
}

.vehicle-preview {
  border: 0.5px solid #000;
  height: 60mm;
  padding: 1.2mm;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  text-align: center;
}

.vehicle-preview img {
  width: auto;
  height: 100%;
  max-width: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.check-layout {
  margin-bottom: 1.8mm;
}

.check-column {
  width: 50%;
  vertical-align: top;
}

.check-column:first-child {
  padding-inline-end: 1.5mm;
}

.check-column:last-child {
  padding-inline-start: 1.5mm;
}

.check-table th {
  background: #f4f4f4;
  font-weight: 700;
  text-align: center;
}

.check-table .narrow {
  width: 7.5%;
}

.check-table .notes {
  width: 19%;
}

.check-table .group-col {
  width: 5.5%;
}

.check-table td {
  height: 3.9mm;
  padding: 0.55mm 0.9mm;
}

.text-ar {
  direction: rtl;
  text-align: right;
  unicode-bidi: plaintext;
}

.text-en {
  direction: ltr;
  text-align: left;
}

.center {
  text-align: center;
}

.notes-cell {
  word-break: break-word;
}

.group-label {
  position: relative;
  padding: 0;
  text-align: center;
  vertical-align: middle;
}

.group-label-text {
  position: absolute;
  top: 50%;
  left: 50%;
  white-space: nowrap;
  font-weight: 600;
  letter-spacing: 0.03em;
  transform: translate(-50%, -50%) rotate(-90deg);
}

.approval-table {
  margin-bottom: 1.8mm;
}

.approval-table .label {
  width: 26%;
  font-weight: 600;
}

.approval-table .value {
  width: 48%;
}

.approval-table .label.ar {
  width: 26%;
  direction: rtl;
  text-align: right;
}

.driver-table .label {
  font-weight: 600;
  white-space: nowrap;
}

.driver-table .value {
  word-break: break-word;
}

.driver-table .label:nth-child(1) {
  width: 18%;
}

.driver-table .value:nth-child(2) {
  width: 13%;
}

.driver-table .label:nth-child(3) {
  width: 11%;
}

.driver-table .value:nth-child(4) {
  width: 12%;
}

.driver-table .label:nth-child(5) {
  width: 12%;
}

.driver-table .value:nth-child(6) {
  width: 12%;
}

.driver-table .label:nth-child(7) {
  width: 11%;
}

.driver-table .value:nth-child(8) {
  width: 11%;
}

.bottom-section {
  page-break-inside: avoid;
  break-inside: avoid;
}

.signature-section {
  position: absolute;
  bottom: 12mm;
  left: 5mm;
}

.saptco-signature {
  max-width: 35mm;
  height: auto;
  display: block;
}
</style>
